const RECAPTCHA_SITE_KEY = '6Ld-VfsrAAAAAEArCPGFRIriiRAMZCloQ_SCRl9d';

type GrecaptchaApi = {
  ready: (callback: () => void) => void
  execute: (siteKey: string, options: { action: string }) => Promise<string>
}

function getGrecaptcha(): GrecaptchaApi | null {
  const grecaptcha = (window as any).grecaptcha as GrecaptchaApi | undefined;
  if (!grecaptcha || !grecaptcha.ready || !grecaptcha.execute) {
    return null;
  }

  return grecaptcha;
}

/**
 * Execute reCAPTCHA v3 and return a token for the supplied action
 *
 * @throws Error when grecaptcha is unavailable or execution fails
 */
export function executeRecaptcha(action: string): Promise<string> {
  const grecaptcha = getGrecaptcha();
  if (!grecaptcha) {
    throw new Error('Verification service not available. Please try again.');
  }

  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(RECAPTCHA_SITE_KEY, { action })
        .then((token: string) => {
          if (!token) {
            reject(new Error('Please complete the verification'));
            return;
          }
          resolve(token);
        })
        .catch(() => {
          reject(new Error('Please complete the verification'));
        });
    });
  });
}
